export default function ListSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      {/* Room list header skeleton */}
      <div className="flex items-center justify-between">
        <div className="h-7 w-40 animate-pulse rounded bg-gray-200" /> {/* Title */}
        <div className="h-7 w-24 animate-pulse rounded bg-gray-200" /> {/* Sort dropdown */}
      </div>
      {/* Filter chip skeleton */}
      <div className="mb-2 flex gap-2">
        {[...Array(4)].map((_, idx) => (
          <div key={idx} className="h-8 w-20 animate-pulse rounded-full bg-gray-200" />
        ))}
      </div>
      {/* Room card skeletons */}
      <div className="flex animate-pulse flex-col gap-4">
        {[...Array(5)].map((_, idx) => (
          <div
            key={idx}
            className="flex items-center gap-4 rounded-lg border border-gray-100 bg-white p-4 shadow-sm"
          >
            <div className="h-16 w-16 rounded-lg bg-gray-200" />
            <div className="flex-1 space-y-2">
              <div className="h-5 w-2/3 rounded bg-gray-200" />
              <div className="h-4 w-1/2 rounded bg-gray-200" />
              <div className="h-4 w-1/3 rounded bg-gray-200" />
            </div>
            <div className="h-8 w-20 rounded bg-gray-200" />
          </div>
        ))}
      </div>
    </div>
  )
}
